import './App.css';
import ApresentationSection from './sections/ApresentationSection';
import EquipmentSection from './sections/EquipmentSection';
import StructureSection from './sections/StructureSection';
import Header from './components/Header';
import ContactSection from './sections/ContactSection';
import ValuesSection from './sections/ValuesSection';
import FixedComponents from './components/FixedComponents';
import GallerySection from './sections/GallerySection';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    const handleSmoothScroll = (event) => {
      const anchor = event.target;
      if (anchor.tagName === 'A' && anchor.getAttribute('href').startsWith('#')) {
        event.preventDefault();
        const targetId = anchor.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    };

    document.addEventListener('click', handleSmoothScroll);
    
    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener('click', handleSmoothScroll);
    };
  }, []);
  return (
    <>

      <Header>
        <ApresentationSection />
        <StructureSection />
        <EquipmentSection />
        <ValuesSection />
        <GallerySection />
        <ContactSection />
      </Header>
      <FixedComponents />
      
    </>
  );
}

export default App;
